import { BottomNavigation, BottomNavigationAction, paletteColors } from '@evaneos/b2b-ui';
import FolderIcon from '@evaneos/b2b-ui/icons/FolderOutlined';
import DiscussionIcon from '@evaneos/b2b-ui/icons/ForumOutlined';
import { useIntl } from 'react-intl';

export type TabType = 'information' | 'discussion';

interface MobileNavigationProps {
    activeTab: TabType;
    onTabChange: (newTab: TabType) => void;
}

export const MobileNavigation = ({ activeTab, onTabChange }: MobileNavigationProps) => {
    const { formatMessage } = useIntl();

    return (
        <BottomNavigation
            showLabels
            value={activeTab}
            onChange={(_event, newValue) => {
                onTabChange(newValue);
            }}
            sx={{
                display: { xs: 'flex', md: 'none' },
                flexShrink: 0,
                borderTop: '1px solid',
                borderColor: 'divider',
                backgroundColor: paletteColors.neutral[100],
                '& .MuiBottomNavigationAction-root .MuiBottomNavigationAction-label': {
                    fontSize: '12px',
                    fontWeight: 'bold',
                },
            }}
        >
            <BottomNavigationAction
                label={formatMessage({ id: 'dossier.information.navbar_title' })}
                icon={<FolderIcon sx={{ fontSize: '16px' }} />}
                value="information"
            />
            <BottomNavigationAction
                label={formatMessage({ id: 'dossier.discussion.title' })}
                icon={<DiscussionIcon sx={{ fontSize: '16px' }} />}
                value="discussion"
            />
        </BottomNavigation>
    );
};
